import { useLocation } from "react-router-dom";
import dataJson from "@/../public/data.json";
import { footerBgPath } from "@/utils/base";
import { publicPath } from "@/utils/base";

type LinkListType = {
  title: string;
  url: string;
};
type LinksType = {
  title: string;
  list: LinkListType[];
};
import "./index.less";
const prefix = "footer";
const Footer: React.FC = () => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className={`${prefix} ${footerBgPath.some((path) => pathname === path) ? "hasBg" : ""}`}>
      {footerBgPath.some((path) => pathname === path) ? (
        <div className={`${prefix}-bg`} style={{ backgroundImage: `url(${dataJson.footer.bg_img})` }}></div>
      ) : null}

      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-links`}>
          {dataJson.footer.link_arr.map((item: LinksType, index: number) => {
            return (
              <div key={index}>
                <div className={`${prefix}-content-title`}>{item.title}</div>
                {item.list.map((ele: LinkListType, idx: number) => {
                  return (
                    <div key={idx}>
                      <span
                        onClick={() => {
                          window.open(publicPath + ele.url, "_self");
                        }}
                        className={`${prefix}-link-title`}
                      >
                        {ele.title}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
